import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import InputText from '../Common/InputText';
import Routes from '../../constants/routes';
import { FREE_TRIAL_URL_PARAMS_FROM_MARKETING_SITE as URLParams } from '../../constants/constants';
import Button from '../Common/Button';
import MultiSelectBox from '../Common/MultiSelectBox/MultiSelectBox';
import { actions as accountActions } from '../../actions/accountActions';
import * as types from '../../constants/actionTypes';
import { bindActionCreators } from 'redux';
import LoadingIndicator from '../Common/LoadingIndicator/LoadingIndicator';
import LoginStyleWrapper from '../Common/LoginStyleWrapper/LoginStyleWrapper';
import Notification from '../Common/Notification';
import { isValidEmailAddress } from '../../helpers/validation';
import './FreeTrialSignUp.scss';
import URLSearchParams from '@ungap/url-search-params'; // URLSearchParams polyfill for IE11

export class FreeTrialSignUp extends React.Component {
	constructor(props, context) {
		super(props, context);

		this.state = {
			isLoading: false,
			isFormValid: true,
			firstName: '',
			lastName: '',
			email: '',
			userName: '',
			password: '',
			passwordConfirm: '',
			workPhone: '',
			jobTitle: '',
			companyName: '',
			templateId: '',
			countryId: '',
			templates: [],
			countries: [],
			error: null,
			showPasswordComplexityRules: false,

			isValidEmail: true,
			isValidPassword: true,
			isAggreementChecked: false,
			isSubmitted: false,

			template: ''
		};
	}

	loadFilters = async () => {
		try {
			this.setState({ isLoading: true });
			var response = await this.props.accountActions.loadFreeTrialSignUpFilters();

			if (response.type === types.LOAD_FREE_TRIAL_SIGN_UP_FILTERS_SUCCESS) {
				const template = this.state.template
					? response.payload.templateSubscriptions.find((x) => x.name.toLowerCase() === this.state.template.toLowerCase())
					: undefined;

				this.setState({
					templates: response.payload.templateSubscriptions,
					countries: response.payload.countries,
					templateId: template?.id ?? ''
				});
			} else if (response.type === types.LOAD_FREE_TRIAL_SIGN_UP_FILTERS_FAILURE) {
				Notification('error', 'Error', response.payload.message);
			}
		} catch (error) {
			Notification('error', 'Error', error);
		} finally {
			this.setState({ isLoading: false });
		}
	};

	onFormChange = (e) => {
		this.setState({ [e.target.name]: e.target.value });
	};

	componentDidMount = () => {
		document.title = 'Pacer';
		this.loadFilters();
		this.getURLParams();
	};

	onMultiSelectChange = (value, name) => {
		this.setState({ [name]: value });
	};

	redirect() {
		this.props.history.push(Routes.Root);
	}

	validateForm = () => {
		if (!(this.state.email && this.state.email.trim().length > 0 && isValidEmailAddress(this.state.email))) {
			return false;
		}
		if (!this.state.isAggreementChecked) {
			Notification('error', 'Error', 'You must agree to the Master Subscription Agreement', true);
			return false;
		}
		return (
			this.state.firstName &&
			this.state.firstName.trim().length > 0 &&
			this.state.lastName &&
			this.state.lastName.trim().length > 0 &&
			this.state.jobTitle &&
			this.state.jobTitle.trim().length > 0 &&
			this.state.companyName &&
			this.state.companyName.trim().length > 0 &&
			this.state.templateId &&
			this.state.templateId != null &&
			this.state.countryId &&
			this.state.countryId != null
		);
	};

	submitFreeTrialSignUp = async (event) => {
		event.preventDefault();

		if (!this.validateForm()) {
			this.setState({ isFormValid: false });
			return;
		}

		this.setState({ isLoading: true });
		try {
			const { firstName, lastName, email, userName, password, passwordConfirm, workPhone, jobTitle, companyName, templateId, countryId } =
				this.state;
			var response = await this.props.accountActions.freeTrialSignUp({
				firstName,
				lastName,
				email,
				userName,
				password,
				passwordConfirm,
				workPhone,
				jobTitle,
				companyName,
				templateId,
				countryId,
			});

			if (response.type === types.FREE_TRIAL_SIGN_UP_SUCCESS) {
				if (!response.payload.isError) {
					this.setState({ isSubmitted: true });
				} else {
					if (response.payload.errors.length > 0) {
						Notification('error', 'Error', response.payload.errors[0].Message, true);
					}
					this.setState({ isValidEmail: response.payload.isValidEmail });
					this.setState({ isValidPassword: response.payload.isValidPassword });

					if (!response.payload.isValidPassword) {
						this.setState({
							showPasswordComplexityRules: true,
							password: '',
							passwordConfirm: '',
						});
					}
				}
			} else if (response.type === types.FREE_TRIAL_SIGN_UP_FAILURE) {
				Notification('error', 'Error', response.payload.message, true);
			}
		} catch (error) {
			Notification('error', 'Error', error);
		} finally {
			this.setState({ isLoading: false });
		}
	};

	loginNow = () => {
		this.redirect('/login');
	};

	getURLParams = () => {
		let urlParams = {
			firstName: '',
			lastName: '',
			email: '',
			company: '',
			template: '',
		};
		const searchParams = new URLSearchParams(this.props.location.search);

		if (searchParams.has(URLParams.firstName)) {
			urlParams.firstName = searchParams.get(URLParams.firstName);
		}
		if (searchParams.has(URLParams.lastName)) {
			urlParams.lastName = searchParams.get(URLParams.lastName);
		}
		if (searchParams.has(URLParams.email)) {
			urlParams.email = searchParams.get(URLParams.email).toLowerCase();
		}
		if (searchParams.has(URLParams.company)) {
			urlParams.company = searchParams.get(URLParams.company);
		}
		if (searchParams.has(URLParams.template)) {
			urlParams.template = searchParams.get(URLParams.template);
		}

		this.setState({
			firstName: urlParams.firstName,
			lastName: urlParams.lastName,
			email: urlParams.email,
			companyName: urlParams.company,
			template: urlParams.template
		});
	};

	render() {
		return (
			<LoginStyleWrapper isWide={true}>
				<LoadingIndicator isLoading={this.state.isLoading} isFullscreen={false} hideWhileLoading={true}>
					<div className='free-trial-user-form'>
						{this.state.isSubmitted ? (
							<div className='submitted-message'>
								<p>Welcome to Pacer!</p>
								<p>
									We&apos;ve created a workspace for you and your team to explore Pacer. Please check your email for a link to create your password. (If you don&apos;t see it, check your spam folders and whitelist the getpacer.com domain so that we can guide you through your free trial period.)
								</p>
								<p>
									Over the next 30 days, we&apos;ll send update emails with FAQs and other suggested tasks that will shorten your learning curve. You can also explore our <a href='https://ehsolution.zendesk.com/hc/en-us/' target='blank'>knowledgebase</a> for self-guided learning, or contact <a href='mailto:support@getpacer.com'>support@getpacer.com</a> with any troubleshooting questions.
								</p>
								<Button type='submit' onClick={this.loginNow} bootstrapClass='outline-light' text={'Start Building'} />
							</div>
						) : (
							<form noValidate className={this.state.isFormValid ? '' : 'was-validated'}>
								<div className='row'>
									<div className='col-12 col-sm-6 order-md-1'>
										<InputText
											name='firstName'
											placeholder='First Name'
											type='text'
											value={this.state.firstName}
											onChange={this.onFormChange}
											isRequired={true}
											errorMessage='First Name is required'
										/>
									</div>
									<div className='col-12 col-sm-6 order-md-3'>
										<InputText
											name='lastName'
											placeholder='Last Name'
											type='text'
											value={this.state.lastName}
											onChange={this.onFormChange}
											isRequired={true}
											errorMessage='Last Name is required'
										/>
									</div>
									<div className='col-12 col-sm-6 order-md-2'>
										<InputText
											name='email'
											isValid={this.state.isValidEmail}
											placeholder='Email'
											type='email'
											value={this.state.email}
											onChange={this.onFormChange}
											isRequired={true}
											errorMessage='Email is required'
											hintText="We'll send your password to this email"
											hintTextWhiteColor={true}
										/>
									</div>
									<div className='col-12 col-sm-6 order-md-4'>
										<InputText
											name='companyName'
											placeholder='Company Name'
											type='text'
											value={this.state.companyName}
											isRequired={true}
											onChange={this.onFormChange}
											errorMessage='Company Name is required'
										/>
									</div>
								</div>

								<div className='row'>
									<div className='col-12 col-sm-6'>
										<InputText
											name='jobTitle'
											placeholder='Job Title'
											type='text'
											value={this.state.jobTitle}
											isRequired={true}
											onChange={this.onFormChange}
											errorMessage='Job Title is required'
										/>
									</div>

									<div className='col-12 col-sm-6'>
										<InputText
											name='workPhone'
											placeholder='Work Phone'
											type='text'
											value={this.state.workPhone}
											isRequired={true}
											onChange={this.onFormChange}
											errorMessage='Work Phone is required'
										/>
									</div>
								</div>
								<div className='row'>
									<div className='col-12 mb-3'>
										<MultiSelectBox
											name='countryId'
											idField='id'
											valueField='name'
											className='text-left'
											options={this.state.countries}
											placeholder='Select Country'
											defaultValue='Select Country'
											selectedValues={this.state.countryId.toString()}
											onChange={this.onMultiSelectChange}
											isMulti={false}
											isRequired={true}
											errorMessage='Country is required'
										/>
									</div>
								</div>
								<div className='row'>
									<div className='col-12 mb-3'>
										<div className='text-center mb-2'>Select your starting point template</div>
										<MultiSelectBox
											name='templateId'
											idField='id'
											valueField='name'
											className='text-left'
											options={this.state.templates}
											placeholder='Select Template'
											defaultValue='Select Template'
											selectedValues={this.state.templateId.toString()}
											onChange={this.onMultiSelectChange}
											isMulti={false}
											isRequired={true}
											errorMessage='Template is required'
										/>
									</div>
								</div>
								<div>
									<div className='mb-2'>
										<input
											className='me-2'
											type='checkbox'
											checked={this.state.isAggreementChecked}
											onChange={() => this.setState({ isAggreementChecked: !this.state.isAggreementChecked })}
										/>
										I agree to the{' '}
										<a
											target='blank'
											href='https://4myrolloutv5prod.blob.core.windows.net/websiteassets/Pacer%20Click-Wrap%20Agreement%20Effective%20March%202022.docx'
											className='download-link'>
											Master Subscription Agreement
										</a>
									</div>
									<div className='mb-3'>
										By registering, you agree to the processing of your personal data by Pacer as described in the{' '}
										<a target='blank' href='https://www.getpacer.com/privacy/' className='download-link'>
											Privacy Statement
										</a>
										.
									</div>
								</div>
								<div className='row'>
									<div className='col-12 text-center'>
										<Button
											type='submit'
											onClick={this.submitFreeTrialSignUp}
											bootstrapClass='outline-light'
											text={'Start Free Trial'}
										/>
									</div>
								</div>
							</form>
						)}
					</div>
				</LoadingIndicator>
			</LoginStyleWrapper>
		);
	}
}

FreeTrialSignUp.propTypes = {
	accountActions: PropTypes.object.isRequired,
	history: PropTypes.object.isRequired,
	location: PropTypes.object.isRequired,
};

function mapDispatchToProps(dispatch) {
	return {
		accountActions: bindActionCreators({ ...accountActions }, dispatch),
	};
}

export default connect(null, mapDispatchToProps)(FreeTrialSignUp);
